/* Countdown for sections/mlp-countdown.liquid.
 *
 * The deadline is a fixed instant (ISO 8601 with an offset), so every shopper
 * sees it arrive at the same moment regardless of where their clock is set.
 * A device with a wrong clock will be wrong; that is the trade for not asking
 * the server every second.
 */
(function () {
  "use strict";

  function pad(n) {
    return n < 10 ? "0" + n : String(n);
  }

  function start(el) {
    var target = Date.parse(el.getAttribute("data-ends-at"));
    if (isNaN(target)) return; // bad date in the theme editor: leave the words

    var fields = {};
    ["days", "hours", "minutes", "seconds"].forEach(function (unit) {
      fields[unit] = el.querySelector('[data-unit="' + unit + '"]');
    });

    var timer;

    function tick() {
      var remaining = target - Date.now();

      if (remaining <= 0) {
        el.setAttribute("data-ended", "true");
        el.removeAttribute("data-running");
        clearInterval(timer);
        return;
      }

      var seconds = Math.floor(remaining / 1000);
      if (fields.days) fields.days.textContent = pad(Math.floor(seconds / 86400));
      if (fields.hours) fields.hours.textContent = pad(Math.floor(seconds / 3600) % 24);
      if (fields.minutes) fields.minutes.textContent = pad(Math.floor(seconds / 60) % 60);
      if (fields.seconds) fields.seconds.textContent = pad(seconds % 60);

      el.setAttribute("data-running", "true");
    }

    tick();
    timer = setInterval(tick, 1000);

    // Theme editor re-renders the section; drop the old interval with it.
    document.addEventListener("shopify:section:unload", function (event) {
      if (event.target.contains(el)) clearInterval(timer);
    });
  }

  function init(root) {
    (root || document).querySelectorAll("[data-mlp-countdown]").forEach(start);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { init(); });
  } else {
    init();
  }
  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
